var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-account-palce",class:_vm.size},[_c('i',{staticClass:"icon-app_follower add-icon"}),_vm._t("icon")],2)}
var staticRenderFns = []

export { render, staticRenderFns }